import { IProduct, IOption, IVariant } from "@tactful/sdk";
import { Button } from "./card";
import { webviews } from "./index";
import { store } from "@/store"; 
import {Cloudinary} from '@/index';

export class Product {

    constructor(){}

    getProductNumber(whatsapp: string) {
        if (whatsapp && whatsapp[0] == "+")
          whatsapp = whatsapp.substring(1,whatsapp.length);
        return `https://api.whatsapp.com/send?phone=${whatsapp}`;
    }
    showSocialMedia(product: IProduct) {
        if (product.item_type && product.item_type != "product") {
            if (product.youtube || product.facebook || product.instagram || product.whatsapp) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }
    detectDirection(lang: string) {
        if (lang == "arabic") {
          return "rtl";
        }
        if (lang == "english") {
          return "ltr";
        }
    }
    formatProductTime(time: string) { //start_time and end_time
        if (time) {
          time = time.substring(0, 5);
          let formatedTime = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
          if (formatedTime.length > 1) {
            //@ts-ignore
            formatedTime = formatedTime.slice(1);
            formatedTime[5] = +formatedTime[0] < 12 ? "AM" : "PM";
            let t = +formatedTime[0] % 12 || 12;
            formatedTime[0] = t.toString();
          }
          return formatedTime.join("");
        }
    }
    formatProductDate(date: string, lang: string) { //open_date and close_date
        if (date) {
            let newDate = new Date(date);
            let language = "";
            if (lang == "arabic") {
                language = "ar-EG";
            }
            if (lang == "english") {
                language = "en-US";
            }
            let options = {
                month: "short",
                day: "numeric",
                year: "numeric"
            };
            //@ts-ignore
            return newDate.toLocaleDateString(language, options);
        }
    }
    getType(product: IProduct, enableDetailsView: boolean, enableBuy: boolean, enableExternalLink: boolean) {
        if (product.use_default_buttons) {
          return this.getDefaultProductAction(enableDetailsView, enableBuy, enableExternalLink);
        } else {
          return this.getProductAction(product);
        }
    }
    getDefaultProductAction(enableDetailsView: boolean, enableBuy: boolean, enableExternalLink: boolean) {
        if (enableDetailsView) {
            return "Show Details";
        } else if (enableBuy) {
            return "Buy/Order";
        } else if (enableExternalLink) {
            return "Visit Website";
        }
    }
    getProductAction(product: IProduct) {
        if (
          product.action1_type == "Buy/Order" ||
          product.action2_type == "Buy/Order" ||
          product.action2_type == "Buy/Order"
        ) {
            return "Buy/Order";
          } else if (
            product.action1_type == "Show Details" ||
            product.action2_type == "Show Details" ||
            product.action2_type == "Show Details"
          ) {
            return "Show Details";
        } else if (
          product.action1_type == "Visit Website" ||
          product.action2_type == "Visit Website" ||
          product.action2_type == "Visit Website"
        ) {
            return "Visit Website";
        } else if (
          product.action1_type == "Call Phone" ||
          product.action2_type == "Call Phone" ||
          product.action2_type == "Call Phone"
        ) {
            return "Call Phone";
        } else if (
          product.action1_type == "Watch Video" ||
          product.action2_type == "Watch Video" ||
          product.action2_type == "Watch Video"
        ) {
            return "Watch Video";
        }
    }
    setVariantValue(options: IOption[], variant: IVariant) {
      let validOptions = options && options.length;
      let validVariant = variant && variant.options && variant.options.length;
      if (validOptions && validVariant) {
        options.forEach(option => {
          //@ts-ignore
          variant.options.forEach((op: IOption) => {
            if (op && op.name && op.name == option.name && !op.value && option.value) {
              op.value = option.value;
            }
          });
        });
      }
      return variant;
    }
    getEmbedVideoUrl(link: string) {
      let regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
      let match;
      if (link) {
        match = link.match(regExp);
      }
      if (match && match[2].length == 11) {
        return "//www.youtube.com/embed/" + match[2];
      } else {
        return link;
      }
    }
    formatPrice(value: number) {
      let val = (value / 1).toFixed(2).replace(",", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    checkVaraint(product: IProduct, variant: IVariant) {
      let isOptionsStructure =  product.options_structure && product.options_structure.length > 0;
      if(!isOptionsStructure){
        return true;
      }
      let isVariant = variant && variant.options && variant.options.length > 0;
      if (isVariant) {
        //@ts-ignore
        return variant.options.every((option: IOption) => option.name && option.value);
      } else {
        return false;
      }
    }
    checkActionType(actionName: string, actionType: string) {
      let excludeActions = [
        "Show Details",
        "Browse items",
        "Browse News / Posts",
        "Call Phone",
        "Visit Website"
      ];
      return  actionName && actionType && !excludeActions.includes(actionType);
    }
    formatAction(action: string){
      if(action && action.includes('_')){
        let splitedAction = action.split("_");
          return splitedAction[0];
      }
      return action;
    }
    getSku(actionType: string) {
      let sku = null;
      if (actionType.includes("_")) {
        let action = actionType.split("_");
        if (action && action.length) sku = action[1] || null;
      }
      return sku;
    }
    getActionsWithPayloads() {
      return [
        {
          name: "Book",
          payload: "BOOK"
        },
        {
          name: "Reserve",
          payload: "RESERVE"
        },
        {
          name: "Remote Consultation",
          payload: "REMOTE_CONSULTATION"
        },
        {
          name: "View",
          payload: "VIEW"
        },
        {
          name: "Request",
          payload: "REQUEST"
        },
        {
          name: "Buy/Order",
          payload: "SHOW_ORDER"
        },
        {
          name: "Visit Website",
          payload: "OPEN_WEBSITE",
        },
        {
          name: "Watch Video",
          payload: "WATCH_VIDEO",
        },
        {
          name: "Add Ticket",
          payload: "ADD_TICKET"
        },

      ];
    }
    setButton(actions: any,actionName: string, actionType: string, buttons: Button[]) {
      if (this.checkActionType(actionName, actionType)) {

          let formatedAction = this.formatAction(actionType);   // incase action contains sku MUST get action without sku
          let sku = this.getSku(actionType); // get sku if action contains sku for example Request_sku

          let currentAction = actions.find((action: any) => action.name === formatedAction ); // find payload of the action
          let payload = currentAction? currentAction.payload:null;

          buttons.push({
            title:actionName,
            action:actionType,
            payload:payload,
            sku:sku
          });
      }
      return buttons;
    }
    canBuy(product: IProduct, disableAddToCart: boolean) {
      console.log('product', product);
      let isAvailible = product.is_availible;
      let isProductType = product.item_type ===  "product";
      let enableAddToCart = !disableAddToCart;
      let hasPrice =  product.price > 0;
      let hasVariants = product.variants && product.variants.length > 0 ;
      let hasOptionsStructure = product.options_structure && product.options_structure.length > 0 ;
      console.log('return', (isProductType && enableAddToCart && isAvailible) && (hasPrice || hasVariants || hasOptionsStructure));
      return (isProductType && enableAddToCart && isAvailible) && (hasPrice || hasVariants || hasOptionsStructure);
    }
    formatUrl(url: string) {
      if (url && !url.match(/^https?:\/\//i)) {
        url = "http://" + url;
      }
      return url;
    }

  hasVariants(product: IProduct): boolean {
    if (product && product.variants && product.variants.length > 1) {
      return true;
    }
    else if (product && product.variants && product.variants.length == 1) {
      let productHasOptions = product.options_structure && product.options_structure.length;
      let variantHasOptions = product.variants.every(variant => (variant.options && variant.options.length > 0));
      // if single variant that has options, and we have options, then this variant is not a dummy variant.
      // or if there are no options and not variant options, this is a simple variation
      return (productHasOptions && variantHasOptions) || (!productHasOptions && !variantHasOptions);
    }
    else {
      return false;
    }
  }
  
  getProductJson(product: any) {
    try {
      product.source_url = webviews.getWebviewProductUrl(product);

      if (product.images) {
        product.images = product.images.map((img: string) => this.imageURL(img, 'WebImages'));
      }
      if (!this.hasVariants(product)) {
        if (product.variants && product.variants.length == 1)
          product.price = product.variants[0].price;
        product.variants = [];
      }

      //HOW CAN APPLY THE ADDITIONS ?? 
      // let additionsResult = await bot.search.getProductAdditions(product);
      // if (additionsResult && additionsResult.total)
      //   product.additions = additionsResult.items as IProduct[];

      return product;
    } catch (err) {
      console.log('err/ getProductJson : ', err);
      return null;
    }
  }

  imageURL(url: string, transformation?: string) {
    // if (!url && store.profile.state.current_profile.image_link) {
    //     url = store.profile.state.current_profile.image_link;
    // }

    if (!transformation)
      transformation = store.profile.state.settings.transformation;

    let full_url = this.getCloudinaryPublicId(url, store.profile.state.settings.cloudinary);
    let image_url;

    if (transformation)
      image_url = Cloudinary.url(full_url, {
        transformation: [transformation]
      });
    else
      image_url = Cloudinary.url(full_url, {
        transformation: ["default"]
      });
    return image_url;
  }
  
  getCloudinaryPublicId(publicId: string, cloudinaryUrl: string) {
    if (publicId) {
        let profileNameIndex = publicId.indexOf(cloudinaryUrl, 0);
        let fullpath = publicId.includes('http:/') || publicId.includes('https:/');
        if (!fullpath && profileNameIndex != 0)
            publicId = cloudinaryUrl + publicId;
    }
    return publicId;
}
}